import React from 'react';
import { personalakteStyles as ps, colors } from '../styles/personalakteStyles';
import { CompensationType } from '../services/CompensationService';
import styles from './ContractHistoryTimeline.module.css';

interface CompensationFormProps {
  compForm: { type: CompensationType; amount: string; valid_from: string };
  onCompFormChange: (form: { type: CompensationType; amount: string; valid_from: string }) => void;
  compSaving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const CompensationForm: React.FC<CompensationFormProps> = ({
  compForm,
  onCompFormChange,
  compSaving,
  onSave,
  onCancel,
}) => {
  return (
    <div className={styles.inlineCompForm}>
      <div className={styles.compFormTypeRow}>
        <button
          type="button"
          onClick={() => onCompFormChange({ ...compForm, type: 'HOURLY' })}
          className={`${styles.compFormTypeBtn} ${
            compForm.type === 'HOURLY' ? styles.compTypeActive : styles.compTypeInactive
          }`}
        >
          Stundenlohn
        </button>
        <button
          type="button"
          onClick={() => onCompFormChange({ ...compForm, type: 'SALARY' })}
          className={`${styles.compFormTypeBtn} ${
            compForm.type === 'SALARY' ? styles.compTypeActive : styles.compTypeInactive
          }`}
        >
          Gehalt
        </button>
      </div>
      <div className={styles.compFormFieldRow}>
        <div style={{ flex: 1 }}>
          <div className={styles.compFormFieldLabel}>
            {compForm.type === 'HOURLY' ? 'EUR/h' : 'EUR/Monat'}
          </div>
          <input
            type="text"
            inputMode="decimal"
            style={{ ...ps.inputStyle, fontSize: 12, padding: '5px 8px' }}
            value={compForm.amount}
            onChange={e => onCompFormChange({ ...compForm, amount: e.target.value })}
            placeholder={compForm.type === 'HOURLY' ? '16.00' : '3200.00'}
          />
        </div>
        <div style={{ flex: 1 }}>
          <div className={styles.compFormFieldLabel}>Gultig ab</div>
          <input
            type="date"
            style={{ ...ps.inputStyle, fontSize: 12, padding: '5px 8px' }}
            value={compForm.valid_from}
            onChange={e => onCompFormChange({ ...compForm, valid_from: e.target.value })}
          />
        </div>
      </div>
      <div className={styles.compFormActions}>
        <button type="button" onClick={onCancel} className={styles.compFormCancel}>
          Abbrechen
        </button>
        <button
          type="button"
          onClick={onSave}
          disabled={compSaving}
          className={`${styles.compFormSave} ${compSaving ? styles.compFormSaveDisabled : ''}`}
        >
          {compSaving ? 'Speichere...' : 'Speichern'}
        </button>
      </div>
    </div>
  );
};
